import { type FC, useMemo } from "react";
import type { ExploreViewModel } from "src/http/types";
import { StyledExploreOnCity } from "./styled-components";

interface Props {
  explore?: Maybe<ExploreViewModel>;
}

/**
 * The Explore on City Exp Component
 */
export const ExploreOnCity: FC<Props> = ({ explore }) => {
  const exploreConfig = useMemo(
    () => ({
      hideLocationFilter: true,
      showVenueFilter: true,
    }),
    [],
  );

  return <StyledExploreOnCity config={exploreConfig} explore={explore} persistFiltersInUrl />;
};
